import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import Toggle from 'react-toggle';
import { useDispatch, useSelector } from 'react-redux';
import { getDomainUser, statusDomainUpdate } from '../../../redux/MainAction';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import DomainAddModal from './DomainAddModal';

const DomainList = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.Webtracker?.domainUser);

  const [userDomain, setUser] = useState([]);
  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10; // Number of items per page

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editID, setEditID] = useState(false);

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    const pay = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };
    dispatch(getDomainUser(pay));
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleEdit = (id) => {
    setEditID(id);
    toggleModal();
  };

  useEffect(() => {
    if (user?.count && user?.rows) {
      setUser(user?.rows);
      setTotalPages(Math.ceil(user.count / itemsPerPage)); // Calculate total pages
    }
  }, [user, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const onStatusChange = (id) => {
    var st = {
      id: id,
    };
    dispatch(statusDomainUpdate(st));
  };

  console.log('userDomain', userDomain);

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-1 ">
          <h5 className="text-muted col-2"></h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            <Button
              className=""
              size="sm"
              color="primary"
              outline
              onClick={() => handleEdit(false)}
            >
              + Add Domain
            </Button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <DomainAddModal
                open={isModalOpen}
                onClose={toggleModal}
                editID={editID}
              />
              <div className="card m-b-20">
                <div className="card-body">
                  <div>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Logo</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile Number</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userDomain?.length > 0 ? (
                          userDomain?.map((lvs, idx) => (
                            <tr>
                              <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                              <td>
                                {lvs.media && lvs.media.url ? (
                                  <img
                                    src={lvs.media.url}
                                    alt={`${lvs.firstName} ${lvs.lastName}`}
                                    style={{
                                      width: '40px',
                                      height: '40px',
                                      borderRadius: '50%',
                                      marginRight: '10px',
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: '40px',
                                      height: '40px',
                                      borderRadius: '50%',
                                      backgroundColor: 'rgb(13, 71, 161)',
                                      color: 'white',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginRight: '10px',
                                      fontSize: '18px',
                                    }}
                                  >
                                    {lvs.firstName.charAt(0)}
                                  </div>
                                )}
                              </td>
                              <td>
                                {lvs?.firstName} {lvs?.lastName}
                              </td>
                              <td>{lvs?.email}</td>
                              <td>{lvs?.userDetail?.mobile || 'No Number'}</td>
                              <td>
                                <div>
                                  <Toggle
                                    checked={
                                      lvs?.status === 'ACTIVE' ? true : false
                                    }
                                    onChange={() => onStatusChange(lvs?.id)}
                                  />
                                </div>
                              </td>
                              <td>
                                <i
                                  className="fa fa-pencil text-primary"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleEdit(lvs?.id)}
                                ></i>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <Stack
                      spacing={2}
                      style={{ float: 'right', marginRight: '1rem' }}
                    >
                      <Pagination
                        count={totalPages}
                        variant="outlined"
                        shape="rounded"
                        page={page}
                        onChange={handlePageChange}
                      />
                    </Stack>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default DomainList;
